import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/mappingMasaKerjaService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import ReactTimeAgo from 'react-time-ago'
import moment from "moment"

import Select from "react-select"

import IndexBloc from "../Blocs/IndexBlock"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,Label,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"
import {
    AvField,
    AvForm
} from "availity-reactstrap-validation";
import { set } from "lodash"
import SweetAlert from "react-bootstrap-sweetalert"

var reformatOptions = function (raw, label, value) {
    return raw.map(function (data) {
        var newObj = {};
        newObj["label"] = data[label];
        newObj["value"] = data[value];

        return newObj;
    });
}; 

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();
    indexBloc = new IndexBloc();

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }
    
    source
    historyTable = 'mutasirekomendasi'
    defaultOrder = 'hirarki'
    defaultSize = 10
    defaultSort = 'asc'
    historyTableselected = 'mutasirekomendasimutasi'
    defaultOrderselected = 'hirarki'
    defaultSizeselected = 10
    defaultSortselected = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
    configDatatableSelected = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrderselected,
            order: this.defaultSortselected
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            syncUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            defaultSizeselected: 10,
            rows: [],
            rowsselected: [],
            selectedEmployees: [],
            selectedEmployeesname: [],
            selectedPositions: [],
            selectedPositionsname: [],
            selectedWorkunits: [],
            selectedWorkunitsname: [],
            selectedEmployeesReplacement: [],
            selectedEmployeesReplacementname: [],
            selectedposold: [],
            selectedposoldname: [],
            selectedmasakerja: [],
            selectedrank: [],
            
            
            checkedtemp: [],
            totalRow: 0,
            totalRowselected: 0,
            loadingTable: false,
            loadingTableselected: false,
            filter: sessionStorage.getItem(this.historyTable)
            ? JSON.parse(sessionStorage.getItem(this.historyTable))
            : {
              filter_value: "",
              page_number: 1,
              page_size: this.defaultSize,
              sort_order: {
                column: this.defaultOrder,
    
                order: this.defaultSort,
              },
            },
            filterselected: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSizeselected,
                    sort_order: {
                        column: this.defaultSortselected,
                        order: this.defaultSortselected
                    }
                },
                wuAll : [{}],
                dataForm: {},
                positionOption: [],
                employeeOption: [],
                workunitfilter: '',
        }
    }
    
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    // loadData = async () => {
    //     this.setState({
    //         wuAll: this.props.wuall.length > 0 ? [{ value: '', label: 'Semua' }, ...this.props.wuall] : [{ value: '', label: 'Tidak Ada Data' }],
    //         selectedEmployees: [],
    //         selectedPositions: [],
    //         selectedWorkunits: [],
    //         selectedEmployeesReplacement: []
    //     })
    //     /* history Datatable */
    //     sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))
    //     // sessionStorage.setItem(this.historyTableselected, JSON.stringify(this.state.filterselected))

    //     let additionalFilter = this.props.additionalFilter;
    //     // let additionalFilterselected= this.props.additionalFilter;

    //     /* kirim ke server */
    //     let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
    //     // let offsetselected = (this.state.filterselected.page_number-1)*this.state.filterselected.page_size
    //     if(this.state.defaultSize!==this.state.filter.page_size) {
    //         this.setState({
    //             defaultSize: this.state.filter.page_size
    //         })
    //         offset = 0
    //         this.configDatatable.page_number = 1
    //     }
    //     // if(this.state.defaultSizeselected!==this.state.filterselected.page_size) {
    //     //     this.setState({
    //     //         defaultSizeselected: this.state.filterselected.page_size
    //     //     })
    //     //     offsetselected = 0
    //     //     this.configDatatableSelected.page_number = 1
    //     // }
    //     const query = {
    //         search: this.state.filter.filter_value,
    //         notin: this.state.selectedEmployees,
    //         limit: this.state.filter.page_size,
    //         order: this.state.filter.sort_order.column,
    //         sort: this.state.filter.sort_order.order,
    //         workunitfilter: this.state.workunitfilter,
    //         status: 1,
    //         ...additionalFilter
    //     }
    //     // const queryselected = {
    //     //     search: this.state.filterselected.filter_value,
    //     //     notin: this.state.selectedEmployees,
    //     //     limit: this.state.filterselected.page_size,
    //     //     offset: (this.state.filterselected.page_number - 1) * this.state.filterselected.page_size, // Memperbaiki offset agar tidak mengikuti tabel 1
    //     //     order: this.state.filterselected.sort_order.column,
    //     //     sort: this.state.filterselected.sort_order.order,
    //     //     status: 1,
    //     //     ...additionalFilterselected
    //     // }
    //     await this.dataTableBloc.fetchRowTable(query, this.source.token)
    //     // await this.dataTableBloc.fetchRowTableSelected(queryselected, this.source.token)
    // }

    loadData = async () => {
        this.setState({
            wuAll: this.props.wuall.length > 0 ? [{ value: '', label: 'Semua' }, ...this.props.wuall] : [{ value: '', label: 'Tidak Ada Data' }],
            // selectedEmployees: [],
            // selectedPositions: [],
            // selectedPositionsname: [],
            // selectedWorkunits: [],
            // selectedWorkunitsname: [],
            // selectedEmployeesReplacement: [],
            // selectedEmployeesReplacementname: []
        })
        /* history Datatable */
        sessionStorage.setItem(
          this.historyTable,
          JSON.stringify(this.state.filter)
        );
    
        /* kirim ke server */
        let offset =
          (this.state.filter.page_number - 1) * this.state.filter.page_size;
        if (this.state.defaultSize !== this.state.filter.page_size) {
          this.setState({
            defaultSize: this.state.filter.page_size,
          });
          offset = 0;
          this.configDatatable.page_number = 1;
        }
        const query = {
          uuid: this.props.uuid,
          search: this.state.filter.filter_value,
          limit: this.state.filter.page_size,
          offset: offset,
          order: this.state.filter.sort_order.column,
          sort: this.state.filter.sort_order.order,
          workunitfilter: this.state.workunitfilter,
          status: 1,
          is_process: 0
        };
        await this.dataTableBloc.fetchRowTable(query, this.source.token);
      };
    loadDataselected = async () => {
        
        /* kirim ke server */
        let offset =
          (this.state.filterselected.page_number - 1) * this.state.filterselected.page_size;
        if (this.state.defaultSize !== this.state.filterselected.page_size) {
          this.setState({
            defaultSize: this.state.filterselected.page_size,
          });
          offset = 0;
          this.configDatatable.page_number = 1;
        }
        const query = {
          uuid: this.props.uuid,
          search: this.state.filterselected.filter_value,
          limit: this.state.filterselected.page_size,
          offset: offset,
          order: this.state.filterselected.sort_order.column,
          sort: this.state.filterselected.sort_order.order,
          workunitfilter: this.state.workunitfilter,
          status: 1,
          is_process: 0,
          selectedEmployees : this.state.selectedEmployees
        };
        await this.dataTableBloc.fetchRowTableSelected(query, this.source.token);
      };

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
        // this.loadDataselected()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.syncData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    handleSync = () => {
        this.setState({
            confirm: true
        })
    }

    syncData  = async () => {
        let additionalFilter = this.props.additionalFilter;
        
        await this.indexBloc.fetchSync({ 
            uuid: this.state.syncUuid,
            ...additionalFilter
        })
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    exportKetidakhadiranExcel = () =>{
        let additionalFilter = this.props.additionalFilter;
        this.indexBloc.fetchPresensiKetidakhadiranExport({
            //uuid: this.state.uuid,
            ...additionalFilter
        });
    }
    loadworkunit = async () => {
        await this.DataTableBloc.fetchWorkUnitAll({})
    }
    // handlerOnSubmit = (e, values) => {
    //     e.preventDefault()
    //     // console.log(values)
    //     // return 

    //     this.setState({
    //         dataForm: values,
    //         confirm: true
    //     })
    // }
    // submitData = async () => {
    //     await this.dataTableBloc.fetchCreate(this.state.dataForm)
    // }

handlerOnSubmit = (e, values) => {
    e.preventDefault();
    const allData = {
        ...values,
        selectedEmployees: this.state.selectedEmployees,
        selectedPositions: this.state.selectedPositions,
        selectedPositionsname: this.state.selectedPositionsname,
        selectedWorkunits: this.state.selectedWorkunits,
        selectedWorkunitsname: this.state.selectedWorkunitsname,
        selectedEmployeesReplacement: this.state.selectedEmployeesReplacement // Pastikan selectedEmployees berisi data yang benar
    };
    if (this.state.selectedPositions.includes('') || this.state.selectedWorkunits.includes('')) {
        
    this.setState({ alert: true }, () => {
        setTimeout(() => {
            this.setState({ alert: false });
        }, 2000);
    });
    }else{
        this.setState({
            dataForm: allData,
            confirm: true
        });
    }
}
    
    submitData = async () => {
        await this.dataTableBloc.fetchCreate(this.state.dataForm);
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        // this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        // loading: true,
                        loadingTable : true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    console.log(response.result[0])
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        // loading: false,
                        loadingTable : false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.dataTableBloc.rowtableSelectedChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTableselected: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        // loading: true,
                        loadingTableselected : true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    console.log(response.result[0])
                    this.setState({
                        totalRowselected: response.total,
                        rowsselected: response.result,
                        // loading: false,
                        loadingTableselected : false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        
        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.syncChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        // this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        selectedEmployees: [],
                        selectedPositions: [],
                        selectedPositionsname: [],
                        selectedWorkunits: [],
                        selectedWorkunitsname: [],
                        selectedEmployeesReplacement: [],
                        loading: false,
                        success: true,
                    });
                    this.loadData()
                    this.loadDataselected();
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.positionChannel.subscribe((result) => {
            switch (result.status) {
              case apiResponse.COMPLETED:
                console.log(result)
                this.setState({
                  positionOption: reformatOptions(
                    result.data.response.result,
                    "position_name",
                    "position_uuid"
                  ),
                  loadingPosition: false,
                });
                break;
              case apiResponse.ERROR:
                break;
              default:
                break;
            }
          })
          this.dataTableBloc.fetchPosition({});
        this.dataTableBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
              case apiResponse.COMPLETED:
                console.log(result)
                this.setState({
                  employeeOption: reformatOptions(
                    result.data.response.result,
                    "employee_full_name",
                    "employee_uuid"
                  ),
                  loadingEmployee: false,
                });
                break;
              case apiResponse.ERROR:
                break;
              default:
                break;
            }
          })
          this.dataTableBloc.fetchEmployee({});
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.dataTableBloc.rowtableSelectedChannel.unsubscribe()
        this.dataTableBloc.workUnitChannel.unsubscribe()
    }
    columns = [
        // {
        //     key: "employee_uuid",
        //     text: "Pilih",
        //     sortable: true,
        //     cell: record => {
        //         return (
        //             <input 
        //                 // className="btn btn-primary btn-sm"
        //                 type="checkbox" 
        //                 onClick={() => {
        //                     this.setState(prevState => ({
        //                         checkedtemp: [...prevState.checkedtemp, record.employee_uuid]
        //                     }), () => {
        //                         // this.loadData();
        //                     });
        //                 }} 
        //             />
        //         );
        //     }
        // },
        {
            key: "employee_full_name",
            text: "Nama",
            sortable: false,
            cell: record => {
                return record.employee_full_name
            }
        },
        {
            key: "employee_current_position_name",
            text: "Jabatan",
            sortable: false,
            cell: record => {
                return record.employee_current_position_name 
            }
        },
        {
            key: "employee_rank_group_room",
            text: "Golongan",
            sortable: false,
            cell: record => {
                return record.employee_rank_group_room;
            }
        },
        // {
        //     key: "masa_kerja_eselon_1",
        //     text: "Masa Kerja Eselon-1",
        //     sortable: false,
        //     cell: record => {
        //         return record.masa_kerja_eselon_1 === "00:00:00" ? "0 tahun 0 bulan 0 hari" : record.masa_kerja_eselon_1.replace(/day/, 'hari').replace(/haris/, 'hari').replace(/mon/, 'bulan').replace(/bulans/, 'bulan').replace(/year/, 'tahun').replace(/tahuns/, 'tahun'); 
        //     }
        // },
        // {
        //     key: "masa_kerja_eselon_2",
        //     text: "Masa Kerja Eselon-2",
        //     sortable: false,
        //     cell: record => {
        //         return record.masa_kerja_eselon_2 === "00:00:00" ? "0 tahun 0 bulan 0 hari" :record.masa_kerja_eselon_2.replace(/day/, 'hari').replace(/haris/, 'hari').replace(/mon/, 'bulan').replace(/bulans/, 'bulan').replace(/year/, 'tahun').replace(/tahuns/, 'tahun'); 
        //     }
        // },
        {
            key: "masa_kerja_eselon_2",
            text: "Masa Kerja Eselon-2",
            sortable: false,
            cell: record => {
                return record.masa_kerja_eselon_2; 
            }
        },
        {
            key: "action",
            text: "",
            sortable: false,
            cell: record => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                {
                    (!this.state.selectedEmployees.includes(record.employee_uuid))?
                        <Button
                            className="btn btn-light"
                            type="button" 
                            attr
                            onClick={(uuid=record.employee_uuid) => {
                                this.setState(prevState => ({
                                    selectedEmployees: [...prevState.selectedEmployees, record.employee_uuid],
                                    selectedEmployeesname: [...prevState.selectedEmployeesname, record.employee_full_name],
                                    selectedposold: [...prevState.selectedposold, record.employee_current_position_uuid],
                                    selectedposoldname: [...prevState.selectedposoldname, record.employee_current_position_name],
                                    selectedmasakerja: [...prevState.selectedmasakerja, record.masakerja],
                                    selectedrank: [...prevState.selectedrank, record.employee_rank_group_room],
                                    selectedPositions: [...prevState.selectedPositions, ''],
                                    selectedPositionsname: [...prevState.selectedPositionsname, ''],
                                    selectedWorkunits: [...prevState.selectedWorkunits, ''],
                                    selectedWorkunitsname: [...prevState.selectedWorkunitsname, ''],
                                    selectedEmployeesReplacement: [...prevState.selectedEmployeesReplacement, '']
                                }), () => {
                                    this.loadDataselected(); // Memanggil fungsi loadDataSelected
                                });
                                console.log(this.state.selectedEmployees)
                            }} >
                            <i className="fas fa-arrow-left text-success"></i>
                        </Button>
                        :
                    <Button
                        className="btn btn-light"
                        type="button" 
                        disabled
                    >
                        <i className="fas fa-arrow-right text-muted text-success"></i>
                    </Button>
                }
                    </div>
                );
            }
        },
        {
            key: "employee_id",
            text: "Jabatan",
            sortable: true,
            cell: record => {
                const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
                console.log(index)
                return (
                    <>
            
                {
                    (this.state.selectedEmployees && this.state.selectedEmployees.includes(record.employee_uuid))?
                <Select
                    name={`position_${record.employee_uuid}`}
                    errorMessage="Pilih Jabatan"
                    placeholder="Pilih Jabatan"
                    options={this.state.positionOption}
                    isDisabled={false}
                    styles={{ container: (provided) => ({ ...provided, width: '200px' }) }}
                    onChange={(selectedOption) => {
                        // alert(`UUID ${record.employee_uuid} ditemukan di index ke-${index}`);
                        this.setState(prevState => {
                            const updatedPositions = [...prevState.selectedPositions];
                            const updatedPositionsName = [...prevState.selectedPositionsname];
                            updatedPositions[index] = selectedOption.value;
                            updatedPositionsName[index] = selectedOption.label;
                            return {
                                selectedPositions: updatedPositions,
                                selectedPositionsname: updatedPositionsName
                            };
                        });
                        
                    }}
                    value={[{'label':this.state.selectedPositionsname[this.state.selectedEmployees.indexOf(record.employee_uuid)],'value':this.state.selectedPositions[this.state.selectedEmployees.indexOf(record.employee_uuid)]}]}
                    validate={{ required: { value: true } }}
                  />
                  :
                  <Select
                    name={`position_${record.employee_uuid}`}
                    errorMessage="Pilih Jabatan"
                    placeholder="Pilih Jabatan"
                    isDisabled={true}
                    styles={{ container: (provided) => ({ ...provided, width: '200px' }) }} // Memperbesar ukuran kolom
                    />
                }
            </>
                );
            }
        },
        {
            key: "employee_uuid",
            text: "Unit kerja tujuan",
            sortable: true,
            cell: record => {
                const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
                return (
                    <>
                
                {
                    (this.state.selectedEmployees && this.state.selectedEmployees.includes(record.employee_uuid))?
                    <Select
                        name={`work_unit_${record.employee_uuid}`} // Menggunakan UUID pegawai sebagai nama unik
                        required={true}
                        options={[{ value: '', label: 'Semua' }, ...this.props.wuall]}
                        classNamePrefix="select2-unit"
                        styles={{ container: (provided) => ({ ...provided, width: '250px' }) }} // Memperbesar ukuran kolom
                        onChange={(selectedOption) => {
                            // const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
                            this.setState(prevState => {
                                const updatedWorkunits = [...prevState.selectedWorkunits];
                                const updatedWorkunitsName = [...prevState.selectedWorkunitsname];
                                updatedWorkunits[index] = selectedOption.value;
                                updatedWorkunitsName[index] = selectedOption.label;
                                return {
                                    selectedWorkunits: updatedWorkunits,
                                    selectedWorkunitsname: updatedWorkunitsName
                                };
                            });
                            
                        }}
                        value={[{'label':this.state.selectedWorkunitsname[index],'value':this.state.selectedWorkunits[index]}]}
                        errorMessage="Pilih Unit Kerja"
                        placeholder="Pilih Unit Kerja"
                    />
                :
                    <Select
                    name={`work_unit_${record.employee_uuid}`} // Menggunakan UUID pegawai sebagai nama unik
                    required={true}
                    isDisabled={true}
                    styles={{ container: (provided) => ({ ...provided, width: '250px' }) }} // Memperbesar ukuran kolom
                    errorMessage="Pilih Unit Kerja"
                    placeholder="Pilih Unit Kerja"
                    />
                }
            </>
                );
            }
        },
        {
            key: "employee_nip",
            text: "Nama Pegawai Pengganti",
            sortable: true,
            cell: record => {
                const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
                return (
                    <>
                        
                    {
                        (this.state.selectedEmployees && this.state.selectedEmployees.includes(record.employee_uuid))?
                        <Select
                            name={`employee_${record.employee_uuid}`} // Menggunakan UUID pegawai sebagai nama unik
                            required={true}
                            options={this.state.employeeOption}
                            classNamePrefix="select2-unit" 
                            isDisabled={false}
                            styles={{ container: (provided) => ({ ...provided, width: '250px' }) }} // Memperbesar ukuran kolom
                            onChange={(selectedOption) => {
                                const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
                                this.setState(prevState => {
                                    const updatedReplacement = [...prevState.selectedEmployeesReplacement];
                                    const updatedReplacementName = [...prevState.selectedEmployeesReplacementname];
                                    updatedReplacement[index] = selectedOption.value;
                                    updatedReplacementName[index] = selectedOption.label;
                                    return {
                                        selectedEmployeesReplacement: updatedReplacement,
                                        selectedEmployeesReplacementname: updatedReplacementName,
                                    };
                                });
                            }}
                            value={[{'label':this.state.selectedEmployeesReplacementname[index],'value':this.state.selectedEmployeesReplacement[index]}]}
                            errorMessage="Pilih Pegawai"
                            placeholder="Pilih Pegawai"
                        />
                        :
                        <Select
                        name={`employee_${record.employee_uuid}`}
                        errorMessage="Pilih Pegawai"
                        placeholder="Pilih Pegawai"
                        isDisabled={true}
                        styles={{ container: (provided) => ({ ...provided, width: '250px' }) }} // Memperbesar ukuran kolom
                        />
                    }
                    </>
                );
            }
            
        },
        {
            key: "employee_nip",
            text: "",
            sortable: false,
            cell: record => {
                const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
                return (
                    <>
                        {
                            (this.state.selectedEmployees && this.state.selectedEmployees.includes(record.employee_uuid))?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button
                                    id={`syncbtn_${record.employee_uuid}`}
                                    className="btn btn-success"
                                    type="button"
                                    onClick={() => {
                                        const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
                                        if (!this.state.selectedEmployees.includes(this.state.selectedEmployeesReplacement[index])) {
                                            this.setState(prevState => ({
                                                selectedEmployees: [...prevState.selectedEmployees, this.state.selectedEmployeesReplacement[index]],
                                                selectedEmployeesname: [...prevState.selectedEmployeesname, this.state.selectedEmployeesReplacementname[index]],
                                                selectedposold: [...prevState.selectedposold, ''],
                                                selectedposoldname: [...prevState.selectedposoldname, ''],
                                                selectedmasakerja: [...prevState.selectedmasakerja, ''],
                                                selectedrank: [...prevState.selectedrank, ''],
                                                // selectedPositions: [...prevState.selectedPositions, record.employee_current_position_uuid],
                                                selectedPositions: [...prevState.selectedPositions, ''],
                                                // selectedPositionsname: [...prevState.selectedPositionsname, record.employee_current_position_name],
                                                selectedPositionsname: [...prevState.selectedPositionsname, ''],
                                                // selectedWorkunits: [...prevState.selectedWorkunits, record.employee_current_work_unit_uuid],
                                                selectedWorkunits: [...prevState.selectedWorkunits, ''],
                                                // selectedWorkunitsname: [...prevState.selectedWorkunitsname, record.employee_current_work_unit_name],
                                                selectedWorkunitsname: [...prevState.selectedWorkunitsname, ''],
                                                selectedEmployeesReplacement: [...prevState.selectedEmployeesReplacement, '']
                                            }), () => {
                                                this.loadDataselected(); // Memanggil fungsi loadDataSelected
                                                // document.getElementById(`syncbtn_${record.employee_uuid}`).disabled = true; // Menonaktifkan tombol
                                            });
                                        }
                                        console.log(`Syncing data for employee work units: ${this.state.selectedWorkunitsname}`);
                                    }}
                                >
                                    <i className="fas fa-sync"></i>
                                </Button>
                            </div>
                            :
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button
                                    className="btn btn-primary"
                                    type="button"
                                    isDisabled={true}
                                    onClick={() => {
                                        // Tambahkan logika untuk melakukan sinkronisasi di sini
                                        console.log(`Syncing data for employee: ${record.employee_uuid}`);
                                    }}
                                >
                                    <i className="fas fa-sync"></i>
                                </Button>
                            </div>
                        }
                    </>
                );
            }
            
        }
    ]
    columnsselected = [
        {
            key: "employee_full_name",
            text: "Nama",
            sortable: false,
            cell: record => {
                return record.employee_full_name
            }
        },
        {
            key: "employee_current_position_name",
            text: "Jabatan",
            sortable: false,
            cell: record => {
                return record.employee_current_position_name 
            }
        },
        {
            key: "employee_rank_group_room",
            text: "Golongan",
            sortable: false,
            cell: record => {
                return record.employee_rank_group_room;
            }
        },
        // {
        //     key: "masa_kerja_eselon_1",
        //     text: "Masa Kerja Eselon-1",
        //     sortable: false,
        //     cell: record => {
        //         return record.masa_kerja_eselon_1 === "00:00:00" ? "0 tahun 0 bulan 0 hari" : record.masa_kerja_eselon_1.replace(/day/, 'hari').replace(/haris/, 'hari').replace(/mon/, 'bulan').replace(/bulans/, 'bulan').replace(/year/, 'tahun').replace(/tahuns/, 'tahun'); 
        //     }
        // },
        // {
        //     key: "masa_kerja_eselon_2",
        //     text: "Masa Kerja Eselon-2",
        //     sortable: false,
        //     cell: record => {
        //         return record.masa_kerja_eselon_2 === "00:00:00" ? "0 tahun 0 bulan 0 hari" :record.masa_kerja_eselon_2.replace(/day/, 'hari').replace(/haris/, 'hari').replace(/mon/, 'bulan').replace(/bulans/, 'bulan').replace(/year/, 'tahun').replace(/tahuns/, 'tahun'); 
        //     }
        // },
        {
            key: "masa_kerja_eselon_2",
            text: "Masa Kerja Eselon-2",
            sortable: false,
            cell: record => {
                return record.masa_kerja_eselon_2; 
            }
        },
        {
            key: "action",
            text: "",
            sortable: false,
            cell: record => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                {
                    (!this.state.selectedEmployees.includes(record.employee_uuid))?
                        <Button
                            className="btn btn-light"
                            type="button" 
                             >
                            <i className="fas fa-arrow-left text-success"></i>
                        </Button>
                        :
                    <Button
                        className="btn btn-light"
                        type="button" 
                        disabled
                    >
                        <i className="fas fa-arrow-right text-muted text-success"></i>
                    </Button>
                }
                    </div>
                );
            }
        },
        // {
        //     key: "employee_id",
        //     text: "Jabatan",
        //     sortable: true,
        //     cell: record => {
        //         const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
        //         return (
        //             <>
            
        //         {
        //             (this.state.selectedEmployees && this.state.selectedEmployees.includes(record.employee_uuid))?
        //         <Select
        //             name={`position_${record.employee_uuid}`}
        //             errorMessage="Pilih Jabatan"
        //             placeholder="Pilih Jabatan"
        //             options={this.state.positionOption}
        //             isDisabled={true}
        //             styles={{ container: (provided) => ({ ...provided, width: '200px' }) }}
        //             value={[{'label':this.state.selectedPositionsname[this.state.selectedEmployees.indexOf(record.employee_uuid)],'value':this.state.selectedPositions[this.state.selectedEmployees.indexOf(record.employee_uuid)]}]}
        //           />
        //           :
        //           <Select
        //             name={`position_${record.employee_uuid}`}
        //             errorMessage="Pilih Jabatan"
        //             placeholder="Pilih Jabatan"
        //             isDisabled={true}
        //             styles={{ container: (provided) => ({ ...provided, width: '200px' }) }} // Memperbesar ukuran kolom
        //             />
        //         }
        //     </>
        //         );
        //     }
        // },
        {
            key: "employee_id",
            text: "Jabatan",
            sortable: false,
            cell: record => {
                return this.state.selectedPositionsname[this.state.selectedEmployees.indexOf(record.employee_uuid)];
            }
        },
        // {
        //     key: "employee_uuid",
        //     text: "Unit kerja tujuan",
        //     sortable: true,
        //     cell: record => {
        //         const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
        //         return (
        //             <>
                
        //         {
        //             (this.state.selectedEmployees && this.state.selectedEmployees.includes(record.employee_uuid))?
        //             <Select
        //                 name={`work_unit_${record.employee_uuid}`} // Menggunakan UUID pegawai sebagai nama unik
        //                 required={true}
        //                 // options={[{ value: '', label: 'Semua' }, ...this.props.wuall]}
        //                 classNamePrefix="select2-unit"
        //                 styles={{ container: (provided) => ({ ...provided, width: '250px' }) }} // Memperbesar ukuran kolom
        //                 isDisabled={true}
        //                 // value={[{'label':this.state.selectedWorkunitsname[index],'value':this.state.selectedWorkunits[index]}]}
        //                 value={[{label:this.state.selectedWorkunitsname[this.state.selectedEmployees.indexOf(record.employee_uuid)],value:this.state.selectedWorkunits[this.state.selectedEmployees.indexOf(record.employee_uuid)]}]}
        //             />
        //         :
        //             <Select
        //             name={`work_unit_${record.employee_uuid}`} // Menggunakan UUID pegawai sebagai nama unik
        //             required={true}
        //             isDisabled={true}
        //             styles={{ container: (provided) => ({ ...provided, width: '250px' }) }} // Memperbesar ukuran kolom
        //             />
        //         }
        //     </>
        //         );
        //     }
        // },
        {
            key: "employee_uuid",
            text: "Unit Kerja Tujuan",
            sortable: false,
            cell: record => {
                return this.state.selectedWorkunitsname[this.state.selectedEmployees.indexOf(record.employee_uuid)];
            }
        },
        // {
        //     key: "employee_nip",
        //     text: "Nama Pegawai Pengganti",
        //     sortable: true,
        //     cell: record => {
        //         const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
        //         return (
        //             <>
                        
        //             {
        //                 (this.state.selectedEmployees && this.state.selectedEmployees.includes(record.employee_uuid))?
        //                 <Select
        //                     name={`employee_${record.employee_uuid}`} // Menggunakan UUID pegawai sebagai nama unik
        //                     required={true}
        //                     options={this.state.employeeOption}
        //                     classNamePrefix="select2-unit" 
        //                     isDisabled={true}
        //                     styles={{ container: (provided) => ({ ...provided, width: '250px' }) }} // Memperbesar ukuran kolom
                            
        //                     value={[{'label':this.state.selectedEmployeesReplacementname[index],'value':this.state.selectedEmployeesReplacement[index]}]}
        //                 />
        //                 :
        //                 <Select
        //                 name={`employee_${record.employee_uuid}`}
        //                 errorMessage="Pilih Jabatan"
        //                 placeholder="Pilih Jabatan"
        //                 isDisabled={true}
        //                 styles={{ container: (provided) => ({ ...provided, width: '250px' }) }} // Memperbesar ukuran kolom
        //                 />
        //             }
        //             </>
        //         );
        //     }
        // },
        {
            key: "employee_nip",
            text: "Nama Pegawai Pengganti",
            sortable: false,
            cell: record => {
                const index = this.state.selectedEmployees.indexOf(record.employee_uuid);
                return this.state.selectedEmployeesReplacementname[index];
            }
        },
    {
        key: "action_delete",
        text: "Aksi",
        sortable: false,
        cell: (record, index) => {
            return (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        className="btn btn-danger"
                        type="button"
                        onClick={() => {
                        const updatedSelectedEmployees = this.state.selectedEmployees.filter(uuid => uuid !== record.employee_uuid);
                        const updatedSelectedEmployeesName = this.state.selectedEmployeesname.filter((_, idx) => this.state.selectedEmployees[idx] !== record.employee_uuid);
                        const updatedSelectedPosOld = this.state.selectedposold.filter((_, idx) => this.state.selectedEmployees[idx] !== record.employee_uuid);
                        const updatedSelectedPosOldName = this.state.selectedposoldname.filter((_, idx) => this.state.selectedEmployees[idx] !== record.employee_uuid);
                        const updatedSelectedMasakerja = this.state.selectedmasakerja.filter((_, idx) => this.state.selectedEmployees[idx] !== record.employee_uuid);
                        const updatedSelectedRank = this.state.selectedrank.filter((_, idx) => this.state.selectedEmployees[idx] !== record.employee_uuid);
                        const updatedSelectedPositions = this.state.selectedPositions.filter((_, idx) => this.state.selectedEmployees[idx] !== record.employee_uuid);
                        const updatedSelectedPositionsName = this.state.selectedPositionsname.filter((_, idx) => this.state.selectedEmployees[idx] !== record.employee_uuid);
                        const updatedSelectedWorkunits = this.state.selectedWorkunits.filter((_, idx) => this.state.selectedEmployees[idx] !== record.employee_uuid);
                        const updatedSelectedWorkunitsName = this.state.selectedWorkunitsname.filter((_, idx) => this.state.selectedEmployees[idx] !== record.employee_uuid);
                        const updatedSelectedEmployeesReplacement = this.state.selectedEmployeesReplacement.filter((_, idx) => this.state.selectedEmployees[idx] !== record.employee_uuid);
                        
                        this.setState({
                            selectedEmployees: updatedSelectedEmployees,
                            selectedEmployeesname: updatedSelectedEmployeesName,
                            selectedposold: updatedSelectedPosOld,
                            selectedposoldname: updatedSelectedPosOldName,
                            selectedmasakerja: updatedSelectedMasakerja,
                            selectedrank: updatedSelectedRank,
                            selectedPositions: updatedSelectedPositions,
                            selectedPositionsname: updatedSelectedPositionsName,
                            selectedWorkunits: updatedSelectedWorkunits,
                            selectedWorkunitsname: updatedSelectedWorkunitsName,
                            selectedEmployeesReplacement: updatedSelectedEmployeesReplacement
                        }, () => {
                            this.loadDataselected(); // Memanggil fungsi loadDataSelected
                        });
                        }}
                    >
                        <i className="fas fa-trash"></i>
                    </Button>
                </div>
            );
        }
    },
    ]
    

    render() {
        return (
            <>
                <Row className="mb-3">
                {/* <Col md="6">
                    
                </Col>
                <Col md="6">
                    
                </Col> */}
                </Row>
                {/* <hr /> */}
                <Row className="mb-3">
                    <Col md="12">
                    {/* <br /> */}
                    {
                        (this.state.checkedtemp.length>0)?
                        <button 
                        className="btn btn-primary btn-sm"
                        type="button" 
                        onClick={() => {
                            this.setState(prevState => ({
                                selectedEmployees: [...prevState.selectedEmployees, ...this.state.checkedtemp]
                            }), () => {
                                this.loadData();
                                console.log(this.state.checkedtemp)
                                // Logic to handle sending data to recommendation
                            });
                        }} 
                    ><i className="uil-arrow-up-right"></i> Kirim Ke Rekomendasi</button>
                        :''
                    }
                        <Card>
                            <CardBody>
                                <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) =>
                                        this.handlerOnSubmit(e, values)
                                        }
                                    >
                                    <Row className="mb-3">
                                        <Label className="col-md-2 col-form-label">
                                            Periode Mutasi
                                        </Label>
                                    </Row>
                                    <Row className="mb-2">
                                        <Label>Tanggal</Label>
                                        <Col md="2">
                                            <AvField
                                                type="date" 
                                                name="mapping_period_date"
                                                placeholder="Periode..."
                                                errorMessage="Masukkan Periode"
                                                validate={{ required: { value: true } }}                                       
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                    <Label>Unit Kerja</Label>
                                        <Col md="3">
                                            <Select
                                                id="wu_filter"
                                                name="wu_filter" // Menggunakan UUID pegawai sebagai nama unik
                                                required={true}
                                                options={[{ 'label': 'Semua', 'value': '' }, ...this.props.wuall]}
                                                classNamePrefix="select2-unit"// Memperbesar ukuran kolom
                                                onChange={(selectedOption) => {
                                                    this.setState(prevState => ({
                                                        workunitfilter: selectedOption.value
                                                    }));
                                                    
                                                }}
                                            />
                                        </Col>
                                        <Col md="2">
                                        <Button
                                            className="btn btn-success"
                                            type="button" 
                                            onClick={() => {
                                                this.setTokenAPI();
                                            }} >
                                            <i className="fas fa-search text-white"></i> Cari
                                        </Button>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md="6"><b>Unit Kerja Sekarang</b></Col>
                                        <Col md="6"><b>Unit Kerja Baru</b></Col>
                                    </Row>
                                    <hr />
                                    <MKIDatatable
                                        className={this.configDatatable.tableClass}
                                        config={this.configDatatable}
                                        records={this.state.rows}
                                        // columns={this.columns}
                                        columns={[
                                            ...this.columns,
                                        ]}
                                        dynamic={true}
                                        // minWidth={1000}
                                        total_record={this.state.totalRow}
                                        initial={this.state.filter}
                                        onChange={(filter) => {
                                            this.setState({
                                                loadingTable: true,
                                                filter: filter
                                            }, function () {
                                                this.setTokenAPI()
                                            });
                                        }}
                                        loading={this.state.loadingTable}
                                    />
                                    {
                                    
                                }
                                </AvForm>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                {
                                    (this.state.selectedEmployees.length>0)?
                                    <>
                                        <Row>
                                            <Col md={12}>
                                                <Button color="primary" type="button" className="btn" onClick={this.handlerOnSubmit}>
                                                    <i className="fas fa-spinner fa-spin"></i> Proses
                                                </Button>
                                                &nbsp;
                                                <Button
                                                    className="btn btn-danger"
                                                    type="button"
                                                    onClick={() => {
                                                        this.setState({
                                                            selectedEmployees: [],
                                                            selectedEmployeesname: [],
                                                            selectedposold: [],
                                                            selectedposoldname: [],
                                                            selectedmasakerja: [],
                                                            selectedrank: [],
                                                            selectedPositions: [],
                                                            selectedPositionsname: [],
                                                            selectedWorkunits: [],
                                                            selectedWorkunitsname: [],
                                                            selectedEmployeesReplacement: []
                                                        }, () => {
                                                            this.loadDataselected(); // Memanggil fungsi loadDataSelected
                                                        });
                                                    }}
                                                >
                                                    <i className="fas fa-undo text-white"></i> Reset Pilihan
                                                </Button>
                                            </Col>
                                        </Row>
                                        <hr />
                                    </>:''
                                }

                                <MKIDatatable
                                    className={this.configDatatableSelected.tableClass}
                                    config={this.configDatatableSelected}
                                    records={this.state.rowsselected}
                                    // columns={this.columns}
                                    columns={[
                                        ...this.columnsselected,
                                    ]}
                                    dynamic={true}
                                    // minWidth={1000}
                                    total_record={this.state.totalRowselected}
                                    initial={this.state.filterselected}
                                    onChange={(filterselected) => {
                                        this.setState({
                                            loadingTableselected: true,
                                            filter: filterselected
                                        }, function () {
                                            this.setTokenAPI()
                                        });
                                    }}
                                    loading={this.state.loadingTableselected}
                                />
                            </CardBody>
                        </Card>
                    </Col>

                    {/* <Col md="6">
                    
                        <Card>
                            <CardBody>
                            <AvForm
                                    className="needs-validation"
                                    onValidSubmit={(e, values) =>
                                    this.handlerOnSubmit(e, values)
                                    }
                                >
                                {
                                    (this.state.selectedEmployees.length>0)?
                                    <Button color="success" type="submit" className="btn btn-sm">
                                    <i className="uil-arrow-up-right"></i> Kirim Ke Mutasi Pegawai
                                    </Button>:''
                                }
                                <br /><br />
                                <MKIDatatable
                                    className={this.configDatatableSelected.tableClass}
                                    config={this.configDatatableSelected}
                                    records={this.state.rowsselected}
                                    // columns={this.columns}
                                    columns={[
                                        ...this.columnsselected,
                                    ]}
                                    dynamic={true}
                                    // minWidth={1000}
                                    total_record={this.state.totalRowselected}
                                    initial={this.state.filterselected}
                                    onChange={(filterselected) => {
                                        this.setState({
                                            loadingTable: true,
                                            filterselected: filterselected
                                        }, function () {
                                            this.setTokenAPI()
                                        });
                                    }}
                                    loading={this.state.loadingTable}
                                />
                                </AvForm>
                            </CardBody>
                        </Card>
                    </Col> */}
                </Row>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan mengirimkan daftar pegawai ke rekomendasi mutasi Pegawai?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil diproses"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal diproses"
                    alertTitle="Perhatian!"
                    alertInfo="Semua Jabatan dan Unit Kerja Pegawai pilihan Harus Dilengkapi"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    showAlert={this.state.alert}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/rekap_ketidakhadiran.html?detail&uuid=" + this.state.detailUuid}/>
                : null }
            </>
        )
    }

}

export default TableActiveComponent